import type { Baseline } from '@shared/models/project.model';
import { createProposal } from '@shared/helpers/proposal-factory.helpers';

/**
 * Reset a version's proposals + actions, retaining one empty proposal so the
 * minimum-one-proposal invariant remains true.
 *
 * Used by admin re-migration ({@link ProjectChangeType.VersionClearProposals}) and
 * test fixtures to drop every stored proposal/action without touching the element tree.
 *
 * Returns the same {@link version} reference when there is nothing to clear.
 */
export const clearProposals = (version: Baseline): Baseline => {
  const hasActions = (version.actions?.length ?? 0) > 0;
  if (
    version.proposals?.length === 1 &&
    version.proposals[0]?.actionIds.length === 0 &&
    !hasActions
  ) {
    return version;
  }
  return {
    ...version,
    proposals: [createProposal({ resultsRecord: version.resultsRecord })],
    actions: [],
  };
};
